import { useAuth0 } from '@auth0/auth0-react';
import { useUserState } from '@common/context/userContext';
import Menu from '@ds/components/actions/Menu';
import { ArrowForwardIcon, ExternalLinkIcon, LogoutIcon } from '@ds/icons/generated/material';
import useAppNavigate from '@effects/useAppNavigate';
import { IsValidUser } from '@utils/question-editable';
import React from 'react';

import Config from '../../config';
import UserCard from './UserCard';

const UserMenu: React.FC = () => {
    const [{ user }] = useUserState();
    const isValidUser = IsValidUser(user);
    const { logout } = useAuth0();
    const navigate = useAppNavigate();

    const logoutAction = () => {
        // We now need to clear the token in session storage.
        sessionStorage.clear();
        // Call logout Auth0 functionality to redirect to the origin page.
        logout({ logoutParams: { returnTo: window.location.origin + '/logout' } });
    };

    return (
        <div className="UserMenu">
            <Menu
                placement="bottom-end"
                minWidth={260}
                trigger={
                    <Menu.Button>
                        {user?.claims?.firstName || ''}&nbsp;{user?.claims?.lastName || ''}
                    </Menu.Button>
                }
            >
                <Menu.Header>
                    <UserCard />
                </Menu.Header>
                {/* Only show edit profile if we have user details. */}
                {isValidUser && (
                    <Menu.Item
                        endAdornment={<ArrowForwardIcon />}
                        onSelect={() => navigate('/profile')}
                    >
                        Edit eNVD profile
                    </Menu.Item>
                )}
                <Menu.Item
                    endAdornment={<ExternalLinkIcon />}
                    onSelect={() => {
                        window.location.href = Config.MYMLA_BASE_URL;
                    }}
                >
                    Redirect to MyMLA
                </Menu.Item>
                <Menu.Item
                    danger
                    endAdornment={<LogoutIcon />}
                    onSelect={logoutAction}
                >
                    Logout from eNVD
                </Menu.Item>
            </Menu>
        </div>
    );
};

export default UserMenu;
